import { useTranslation } from 'react-i18next';
import LocalizedTextList from '../LocalizedTextList';
import { type Coverage } from 'dto/marketableProduct';
import i18n from 'i18n';
import { formatNumber } from 'utils';

interface Props {
  coverage: Coverage;
}

const CoverageInfoContent = ({ coverage }: Props) => {
  const { t } = useTranslation(['individualLife']);

  const deductibleDays = coverage.selectableDeductibleDays;

  const additionalInfoTexts = t(
    `coverageProduct.${coverage.coverageProduct}.additionalInfoText`,
    {
      returnObjects: true,
      minSumInsured: formatNumber(coverage.minSumInsured),
      minSumInsuredWithAdditionalCoverages:
        coverage.minSumInsuredWhenOptionalCoverageSelected &&
        formatNumber(coverage.minSumInsuredWhenOptionalCoverageSelected),
      maxSumInsured: formatNumber(coverage.maxSumInsured),
      selectableDeductibleDays: deductibleDays
        ? deductibleDays.length > 1
          ? deductibleDays.slice(0, -1).join(', ') +
            ` ${i18n.t('common.or')} ` +
            `${deductibleDays[deductibleDays.length - 1]}`
          : deductibleDays[0]
        : '',
    }
  ) as string[] | undefined;

  return (
    <div
      className='opux-v6__opds'
      data-testid={`${coverage.coverageProduct}-coverage-info-content`}>
      <LocalizedTextList texts={additionalInfoTexts} />
    </div>
  );
};

export default CoverageInfoContent;
